export default __webpack_public_path__ + "static/image-67-e73b9083f8e519008b370bca652c8310.jpg";